import React, { useState, useEffect } from "react";
import {
  SimpleTableWrapper,
  SimpleTableToolbar,
  SimpleTableTitle,
  SimpleTableContainer,
  SimpleTable,
  SimpleTableHead,
  SimpleTableRow,
  SimpleTableHeader,
  SimpleTableBody,
  SimpleTableData,
  IconVisibility,
  IconVisibilityOff,
  IconContentCopy,
  withTooltip,
  THEMES,
} from "cdk-radial";

const VALUE_LIMIT = 18;

function SecretsTable({ secrets = [] }) {
  const [filteredData, setFilteredData] = useState([]);
  const [visibleRows, setVisibleRows] = useState({});
  const [copied, setCopied] = useState({});

  useEffect(() => {
    setFilteredData(secrets || []);
  }, [secrets]);

  const toggleSecret = (idx) => {
    setVisibleRows((prev) => ({
      ...prev,
      [idx]: !prev[idx],
    }));
  };

  const copyToClipboard = (value, key) => {
    navigator.clipboard.writeText(value);

    setCopied((prev) => ({
      ...prev,
      [key]: true,
    }));

    setTimeout(() => {
      setCopied((prev) => ({
        ...prev,
        [key]: false,
      }));
    }, 1200);
  };

  const renderEllipsisWithTooltip = (value, id) => {
    if (!value) return "";

    if (value.length <= VALUE_LIMIT) return value;

    const tooltipProps = {
      id: `tooltip-${id}`,
      text: value,
      delay: 0,
      theme: THEMES.LIGHT,
    };

    const Component = (props) => (
      <span {...props}>{value.slice(0, VALUE_LIMIT)}…</span>
    );

    const ComponentWithTooltip = withTooltip(Component, tooltipProps);

    return <ComponentWithTooltip />;
  };

  const renderCopyIcon = (value, id) => {
    const tooltipProps = {
      id: `copy-${id}`,
      text: copied[id] ? "Copied!" : "Copy",
      delay: 0,
      theme: THEMES.LIGHT,
    };

    const Component = (props) => (
      <IconContentCopy
        {...props}
        style={{ cursor: "pointer", fontSize: 16 }}
        onClick={() => copyToClipboard(value, id)}
      />
    );

    const ComponentWithTooltip = withTooltip(Component, tooltipProps);

    return <ComponentWithTooltip />;
  };

  const columns = [
    { label: "App Name", field: "appName" },
    { label: "App ID", field: "appId" },
    { label: "Org Name", field: "orgName" },
    { label: "Org ID", field: "orgId" },
    { label: "API Key", field: "apiKey" },
    { label: "API Secret", field: "apiSecret" },
    { label: "Status", field: "status" },
  ];

  return (
    <SimpleTableWrapper>
      <SimpleTableToolbar>
        <SimpleTableTitle>
          App Credentials ({filteredData.length})
        </SimpleTableTitle>
      </SimpleTableToolbar>
      <SimpleTableContainer>
        <SimpleTable>
          <SimpleTableHead>
            <SimpleTableRow>
              {columns.map((col) => (
                <SimpleTableHeader key={col.field}>
                  {col.label}
                </SimpleTableHeader>
              ))}
            </SimpleTableRow>
          </SimpleTableHead>

          <SimpleTableBody>
            {filteredData.length > 0 ? (
              filteredData.map((row, rowIndex) => {
                const secretVisible = visibleRows[rowIndex];

                return (
                  <SimpleTableRow key={rowIndex}>
                    

                    <SimpleTableData>
                      {renderEllipsisWithTooltip(
                        row.appName,
                        `appName-${rowIndex}`,
                      )}
                    </SimpleTableData>
<SimpleTableData>
                      {renderEllipsisWithTooltip(
                        row.appId,
                        `appId-${rowIndex}`,
                      )}
                    </SimpleTableData>
                    <SimpleTableData>
                      {renderEllipsisWithTooltip(
                        row.orgName,
                        `orgName-${rowIndex}`,
                      )}
                    </SimpleTableData>

                    <SimpleTableData>
                      {renderEllipsisWithTooltip(
                        row.orgId,
                        `orgId-${rowIndex}`,
                      )}
                    </SimpleTableData>

                    {/* API KEY */}

                    <SimpleTableData>
                      <div style={styles.cell}>
                        <span style={styles.text}>
                          {renderEllipsisWithTooltip(
                            row.apiKey,
                            `apiKey-${rowIndex}`,
                          )}
                        </span>

                        {renderCopyIcon(row.apiKey, `apiKey-${rowIndex}`)}
                      </div>
                    </SimpleTableData>

                    {/* API SECRET */}

                    <SimpleTableData>
                      <div style={styles.cell}>
                        <span style={styles.text}>
                          {secretVisible
                            ? renderEllipsisWithTooltip(
                                row.apiSecret,
                                `apiSecret-${rowIndex}`,
                              )
                            : "••••••••••••••"}
                        </span>

                        <span
                          style={{ cursor: "pointer" }}
                          onClick={() => toggleSecret(rowIndex)}
                        >
                          {secretVisible ? (
                            <IconVisibilityOff />
                          ) : (
                            <IconVisibility />
                          )}
                        </span>

                        {renderCopyIcon(row.apiSecret, `apiSecret-${rowIndex}`)}
                      </div>
                    </SimpleTableData>

                    <SimpleTableData>
                      {renderEllipsisWithTooltip(
                        row.status,
                        `status-${rowIndex}`,
                      )}
                    </SimpleTableData>
                  </SimpleTableRow>
                );
              })
            ) : (
              <SimpleTableRow>
                <SimpleTableData colSpan={columns.length}>
                  No Data to Display
                </SimpleTableData>
              </SimpleTableRow>
            )}
          </SimpleTableBody>
        </SimpleTable>
      </SimpleTableContainer>
    </SimpleTableWrapper>
  );
}

const styles = {
  cell: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    maxWidth: "260px",
  },

  text: {
    fontFamily: "monospace",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    maxWidth: "180px",
  },
};

export default SecretsTable;
